export const PICLIST = 'pic_list';
export const USERINFO = 'user_info';
export const LOGINSUC = 'login_suc';
export const LOGINERR = 'login_err';
export const FILEUPLOAD = 'file_upload';
export const VIDEOSUB = 'video_sub';


// WEBPACK FOOTER //
// ./src/redux/action-types.js